/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Light_Dove_KnitInputs */

const en_vast_light_dove_knit = /** @type {(inputs: Vast_Light_Dove_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Data`)
};

const de_vast_light_dove_knit = /** @type {(inputs: Vast_Light_Dove_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Daten`)
};

/**
* | output |
* | --- |
* | "Personal Data" |
*
* @param {Vast_Light_Dove_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_light_dove_knit = /** @type {((inputs?: Vast_Light_Dove_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Light_Dove_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_light_dove_knit(inputs)
	return de_vast_light_dove_knit(inputs)
});